import { render, staticRenderFns } from "./PageComingSoon.vue?vue&type=template&id=adf0cfaa&scoped=true"
import script from "./PageComingSoon.vue?vue&type=script&lang=js"
export * from "./PageComingSoon.vue?vue&type=script&lang=js"
import style0 from "./PageComingSoon.vue?vue&type=style&index=0&id=adf0cfaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf0cfaa",
  null
  
)

export default component.exports